var map = {
	"./bg.jpg": "./src/EGRContent/Story/AchamakoSathi/images/bg.jpg",
	"./bg_for_dost_angry.jpg": "./src/EGRContent/Story/AchamakoSathi/images/bg_for_dost_angry.jpg",
	"./bg_for_dost_chatting.jpg": "./src/EGRContent/Story/AchamakoSathi/images/bg_for_dost_chatting.jpg",
	"./bg_for_dost_for_ever.jpg": "./src/EGRContent/Story/AchamakoSathi/images/bg_for_dost_for_ever.jpg",
	"./bhaada.png": "./src/EGRContent/Story/AchamakoSathi/images/bhaada.png",
	"./bhada.png": "./src/EGRContent/Story/AchamakoSathi/images/bhada.png",
	"./bhada_l.png": "./src/EGRContent/Story/AchamakoSathi/images/bhada_l.png",
	"./clouds.png": "./src/EGRContent/Story/AchamakoSathi/images/clouds.png",
	"./cover_banner.png": "./src/EGRContent/Story/AchamakoSathi/images/cover_banner.png",
	"./cover_page.jpg": "./src/EGRContent/Story/AchamakoSathi/images/cover_page.jpg",
	"./dhoka.png": "./src/EGRContent/Story/AchamakoSathi/images/dhoka.png",
	"./dhoka_l.png": "./src/EGRContent/Story/AchamakoSathi/images/dhoka_l.png",
	"./dhooka.png": "./src/EGRContent/Story/AchamakoSathi/images/dhooka.png",
	"./dost_angry.gif": "./src/EGRContent/Story/AchamakoSathi/images/dost_angry.gif",
	"./dost_angry.png": "./src/EGRContent/Story/AchamakoSathi/images/dost_angry.png",
	"./dost_chatting.gif": "./src/EGRContent/Story/AchamakoSathi/images/dost_chatting.gif",
	"./dost_chatting.png": "./src/EGRContent/Story/AchamakoSathi/images/dost_chatting.png",
	"./dost_for_ever.gif": "./src/EGRContent/Story/AchamakoSathi/images/dost_for_ever.gif",
	"./dost_for_ever.png": "./src/EGRContent/Story/AchamakoSathi/images/dost_for_ever.png",
	"./haat.png": "./src/EGRContent/Story/AchamakoSathi/images/haat.png",
	"./hat.png": "./src/EGRContent/Story/AchamakoSathi/images/hat.png",
	"./horse.png": "./src/EGRContent/Story/AchamakoSathi/images/horse.png",
	"./horse_l.png": "./src/EGRContent/Story/AchamakoSathi/images/horse_l.png",
	"./last_page.jpg": "./src/EGRContent/Story/AchamakoSathi/images/last_page.jpg",
	"./last_page_new.jpg": "./src/EGRContent/Story/AchamakoSathi/images/last_page_new.jpg",
	"./leg.png": "./src/EGRContent/Story/AchamakoSathi/images/leg.png",
	"./leg_l.png": "./src/EGRContent/Story/AchamakoSathi/images/leg_l.png",
	"./paathi.png": "./src/EGRContent/Story/AchamakoSathi/images/paathi.png",
	"./paathi_l.png": "./src/EGRContent/Story/AchamakoSathi/images/paathi_l.png",
	"./pataune.png": "./src/EGRContent/Story/AchamakoSathi/images/pataune.png",
	"./pathi.png": "./src/EGRContent/Story/AchamakoSathi/images/pathi.png",
	"./pathi_l.png": "./src/EGRContent/Story/AchamakoSathi/images/pathi_l.png",
	"./pattaune.gif": "./src/EGRContent/Story/AchamakoSathi/images/pattaune.gif",
	"./pattaune.png": "./src/EGRContent/Story/AchamakoSathi/images/pattaune.png",
	"./sing.png": "./src/EGRContent/Story/AchamakoSathi/images/sing.png",
	"./sing_l.png": "./src/EGRContent/Story/AchamakoSathi/images/sing_l.png",
	"./sky.jpg": "./src/EGRContent/Story/AchamakoSathi/images/sky.jpg",
	"./sky_new.jpg": "./src/EGRContent/Story/AchamakoSathi/images/sky_new.jpg",
	"./story-banner.svg": "./src/EGRContent/Story/AchamakoSathi/images/story-banner.svg",
	"./story_thumbnail.png": "./src/EGRContent/Story/AchamakoSathi/images/story_thumbnail.png",
	"./taato.png": "./src/EGRContent/Story/AchamakoSathi/images/taato.png",
	"./tato.png": "./src/EGRContent/Story/AchamakoSathi/images/tato.png",
	"./text_box01.png": "./src/EGRContent/Story/AchamakoSathi/images/text_box01.png",
	"./text_box02.png": "./src/EGRContent/Story/AchamakoSathi/images/text_box02.png",
	"./thumnail_achamba_ka_saathi.svg": "./src/EGRContent/Story/AchamakoSathi/images/thumnail_achamba_ka_saathi.svg",
	"./tokanu.png": "./src/EGRContent/Story/AchamakoSathi/images/tokanu.png",
	"./toknu.png": "./src/EGRContent/Story/AchamakoSathi/images/toknu.png",
	"./tree.png": "./src/EGRContent/Story/AchamakoSathi/images/tree.png",
	"./village.png": "./src/EGRContent/Story/AchamakoSathi/images/village.png",
	"./village_l.png": "./src/EGRContent/Story/AchamakoSathi/images/village_l.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/AchamakoSathi/images sync recursive ^\\.\\/.*$";